import { FechaFunctionsService } from '@/utils/functions.service';
import { Component } from '@angular/core';
import { Color, LegendPosition, ScaleType } from '@swimlane/ngx-charts';
import { AppService } from '@services/app.service';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {
  dataDashboard: any;
  graficoVenta = [];
  graficoVentaMxM = [];
  graficoVentaMxMCompleto = [];
  GraficoTopVentasActual = [];
  GraficoTopVentasAnterior = [];
  diasMxM: string[] = [];
  diaDesdeMxM = '01';
  diaHastaMxM = '31';
  totalMxMActual = 0;
  totalMxMAnterior = 0;
  yAxisTickFormatting = value => `${this.Func.currencyPeso(value)}`;
  pieTooltipText = (arc) =>
    `<span class="tooltip-label">${arc.data.label || arc.data.name}</span>
     <span class="tooltip-val">${this.Func.currencyPeso(arc.data.value)}</span>`;

  colorScheme: Color = {
    name: 'custom',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#00bfff', '#003fff', '#4100ff']
  };

  colorSchemeBlue: Color = {
    name: 'customBlue',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#005ab3', '#0066cc', '#0073e6', '#0080ff','#1a8dff','#3399ff','#4da6ff','#67b3ff','#80c0ff']
  };

  legendPosition = LegendPosition.Below;

  gradient = false;
  showLegend = true;
  showXAxis = true;
  showYAxis = true;
  showXAxisLabel = false;
  showYAxisLabel = false;
  xAxisLabel = 'Categorías';
  yAxisLabel = 'Valores';
  timeline: boolean = false;
  animations: boolean = true;

  constructor(
    private toastr: ToastrService,
    public appService: AppService,
    public generalService: GeneralService,
    public Func: FechaFunctionsService,
    public loadingService: LoadingService,) { }

  async ngOnInit() {
    this.loadingService.setLoading(true)
    await Promise.all([
      this.getData(),
      this.getDataGrafico()
    ]);
    this.loadingService.setLoading(false)
  }


  async getData() {
    try {
      let res = await this.generalService.getListar('pedido/dashboard')
      this.dataDashboard = res.data;
    } catch (error) {
      this.toastr.error('Error al cargar data!')
    }
  }

  async getDataGrafico() {
    try {
      let res = await this.generalService.getListar('pedido/grafico')
      this.graficoVenta = res.data.graficoVenta;
      this.graficoVentaMxMCompleto = res.data.graficoVentaMxM || [];
      this.GraficoTopVentasActual = res.data.GraficoTopVentasActual;
      this.GraficoTopVentasAnterior = res.data.GraficoTopVentasAnterior;
      this.initRangoMxM();
      this.aplicarFiltroMxM();
    } catch (error) {
      this.toastr.error('Error al cargar data!')
    }
  }

  initRangoMxM(): void {
    const dias = new Set<string>();
    (this.graficoVentaMxMCompleto || []).forEach((serie: any) => {
      (serie.series || []).forEach((punto: any) => dias.add(String(punto.name).padStart(2, '0')));
    });
    this.diasMxM = Array.from(dias).sort((a, b) => Number(a) - Number(b));
    this.diaDesdeMxM = this.diasMxM[0] || '01';
    this.diaHastaMxM = this.diasMxM[this.diasMxM.length - 1] || '31';
  }

  onRangoMxMChange(): void {
    if (Number(this.diaDesdeMxM) > Number(this.diaHastaMxM)) {
      const tmp = this.diaDesdeMxM;
      this.diaDesdeMxM = this.diaHastaMxM;
      this.diaHastaMxM = tmp;
    }
    this.aplicarFiltroMxM();
  }

  aplicarFiltroMxM(): void {
    const desde = Number(this.diaDesdeMxM);
    const hasta = Number(this.diaHastaMxM);

    this.graficoVentaMxM = (this.graficoVentaMxMCompleto || []).map((serie: any) => {
      const seriesFiltrada = (serie.series || []).filter((punto: any) => {
        const dia = Number(punto.name);
        return dia >= desde && dia <= hasta;
      });
      return { ...serie, series: seriesFiltrada };
    });

    this.totalMxMActual = this.sumarSerieMxM('Actual');
    this.totalMxMAnterior = this.sumarSerieMxM('Anterior');
  }

  sumarSerieMxM(nombre: string): number {
    const serie = (this.graficoVentaMxM || []).find((s: any) => s.name === nombre);
    if (!serie?.series?.length) return 0;
    return serie.series.reduce((acc: number, punto: any) => acc + (Number(punto.value) || 0), 0);
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
}
